<template>
  <div id='' class='gPageBorder' v-loading='loading'>

    <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        @sort-change="sortChange"
        class='tbPoint'
        style="width: 100%">
        <!-- <el-table-column
          header-align='center'
          align='center'
          prop=""
          :label="$t('app_No')"
          width="70">
          <template slot-scope='scope'>
            <label>{{scope.$index + 1}}</label>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align='center'
          align='center'
          prop="appName"
          sortable="custom"
          :label="$t('app_appName')"
          width="">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appCategoryName"
          width='100'
          :label="$t('app_type')">
        </el-table-column>
        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="appInstallType"
          width='100'
          :label="$t('app_insType')">
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align='center'
          align='center'
          prop="appStatus"
          width='150'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <el-label>{{getStatus(scope.row.appStatus)}}</el-label>
          </template>
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="createTime"
          sortable="custom"
          width='175'
          fformatter="dateFormat"
          :label="$t('app_ulTime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appVersion"
          width='170'
          :label="$t('app_newgVer')">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          width='80'
          :label="$t('app_operate')">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('app_verify')" placement="top">
              <el-button type='text' ><i class="fa fa-check-square-o" style=""></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      <div class="gPgDiv">

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<style>
  /* html,body{width:100%;height:100%;} */
  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}


  #appDepot{min-width:840px;}

  #adData{margin-top:20px;}

  #adUpload{margin-top:30px;overflow:hidden;margin-bottom:30px;}
    #adUpload button{margin-right:10px;width:15%;}
</style>

<script>
  import mm from 'moment'
  export default{
    data () {
      return {
        orderName: '',
        orderType: '',
        mechanismId: window.localStorage['mechanismId'],
        tableData: [],
        appTypes: [],
        appTypeValue: '',
        appStatus: [
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}
        ],
        appStatusValue: '',
        row: this.$gRow,
        total: 0,
        index: 1,
        loading: 0
      }
    },
    computed: {
      index () {
        return this.$getWPage('appVerifyPage')
      }
    },
    methods: {
      sortChange (vl) {
        switch (vl.prop) {
          case 'appName':
            this.orderName = '1'
            break
          case 'createTime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getAppList(this.index)
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      getStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      },
      pageSelect (index) {
        this.getAppList(index)
        this.$setWPage('appVerifyPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getAppList(this.index)
      },
      cellClick (row) {
        // console.log(row)
        var cf = {type: 3, data: row}
        this.$setWObj('editAppConfig', cf)
        this.$router.push({path: '/appView/verify'})
        //this.$router.push({name: this.$t('menu.appManageSub.verifyApp')})
      },
      getAppList (index) {
        this.loading = 1
        var mc = '' /////this.mechanismId
        this.$getAppList1(this.$gRow, index, mc, '', '', '1',this.orderName, this.orderType,'', (res) => {
          // console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.index = index
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
        
        
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    mounted () { 
      this.getAppList(this.index)
      this.$getAppTypeList(100000000, 1, (res) => {
        if (res.status === 200) {
          this.appTypes = res.data
        } else {
          this.$message(res.message)
        }
      }, '')
    }
  }
</script>



// WEBPACK FOOTER //
// review.vue?14a83efa